export default __webpack_public_path__ + "static/media/NCSA_ribbon.99ed3240.jpg";